import React, { ReactChild, useState } from 'react';
import { Global, css } from '@emotion/core';
import BenefitsSuccess from '@olxeu-a2b/ui/src/commons/components/benefits/BenefitsSuccess';
import BenefitsDisabled from '@olxeu-a2b/ui/src/commons/components/benefits/BenefitsDisabled';
import { getConfig, cookie } from '@olxeu-a2b/delivery-utils/src/extras';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import ChatIcon from './assets/Chat.svg';
import DeliveryIcon from './assets/Delivery.svg';
import MoneyIcon from './assets/Money.svg';
import DiscountIcon from './assets/Discount.svg';
import Benefits from './Benefits';
import {
  FAKE_DOOR_FLAG_ID,
  FAKE_DOOR_SESSION_KEY,
  FAKE_DOOR_SESSION_COOKIE,
  FAKE_DOOR_USER_ID_PARAM,
  FAKE_DOOR_TRACKING_KEYS,
} from './constants';
import { ListProps } from './types';

const BENEFITS_LIST = [
  { type: 'delivery', icon: <DeliveryIcon /> },
  { type: 'money', icon: <MoneyIcon /> },
  { type: 'chat', icon: <ChatIcon /> },
  { type: 'discount', icon: <DiscountIcon /> },
] as ListProps[];

const config = getConfig();
const redirectUrl = config?.sites?.desktop?.url;

const BenefitsContainer = ({ featureFlags = getConfig().featureFlags }) => {
  const [selectedBenefit, setSelectedBenefit] = useState<string>('');
  const [hasSubmitted, setHasSubmitted] = useState<string | null>(() =>
    window.localStorage.getItem(FAKE_DOOR_SESSION_KEY),
  );

  const trackEvent = useTrackEvent();

  const query = new URLSearchParams(window.location.search);
  const userId = query.get(FAKE_DOOR_USER_ID_PARAM);
  const sessionCookie = cookie.get(FAKE_DOOR_SESSION_COOKIE);
  const isDisabled = !featureFlags[FAKE_DOOR_FLAG_ID];

  const handleSubmit = () => {
    trackEvent(FAKE_DOOR_TRACKING_KEYS[selectedBenefit], null, null, {
      user_id: userId,
      session_long: sessionCookie,
    });

    window.localStorage.setItem(FAKE_DOOR_SESSION_KEY, 'completed');
    setHasSubmitted('completed');
  };

  const handleBenefitChange = (name: string): void => {
    setSelectedBenefit(name);
  };

  // eslint-disable-next-line react/require-default-props
  const GlobalHeaderStyles = ({ children }: { children?: ReactChild }) => (
    <>
      <Global
        styles={css`
          #page-header-desktop {
            height: 72px;
            box-sizing: border-box;
            padding: 0px 64px;
          }
        `}
      />
      {children}
    </>
  );

  if (isDisabled)
    return (
      <GlobalHeaderStyles>
        <BenefitsDisabled redirectUrl={redirectUrl} />
      </GlobalHeaderStyles>
    );
  if (hasSubmitted)
    return (
      <GlobalHeaderStyles>
        <BenefitsSuccess redirectUrl={redirectUrl} />
      </GlobalHeaderStyles>
    );

  return (
    <>
      <GlobalHeaderStyles />
      <Benefits
        items={BENEFITS_LIST}
        userId={userId}
        selected={selectedBenefit}
        sessionCookie={sessionCookie}
        handleBenefitChange={handleBenefitChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default BenefitsContainer;
